import { Button, Div, H3, Modal, P, PropsModal } from '@vgrubs/components';

export const UnpauseAllProvidersModal = ({
  modalIsOpen,
  closeModal,
  onConfirm,
}: PropsModal & {
  modalIsOpen: boolean;
  onConfirm: () => void;
}) => {
  return (
    <Modal isOpen={modalIsOpen} closeModal={closeModal} logo={false}>
      <H3 $mb="8">Unpause All Providers?</H3>
      <P $mb="16">Are you sure you want to unpause all providers?</P>

      <Div $flex $gap="20px">
        <Div $width="50%">
          <Button
            $selected
            $w="100%"
            $mt="24"
            onClick={() => {
              onConfirm();
              closeModal?.();
            }}
          >
            Yes
          </Button>
        </Div>
        <Div $width="50%">
          <Button
            $selected
            $gray
            $w="100%"
            $mt="24"
            onClick={() => closeModal?.()}
          >
            No
          </Button>
        </Div>
      </Div>
    </Modal>
  );
};
